<div class="w-full ">

      <form #coleccionistaForm="ngForm">

        <mat-form-field
            class="w-full fuse-mat-dense">
            <mat-label>Nombre</mat-label>
            <input matInput type="text" id="nombre" [(ngModel)]="coleccionista.nombre" name="nombre" placeholder="Nombre" required/>
        </mat-form-field>
    
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-2 w-full">
            

            <mat-form-field class="w-full fuse-mat-dense">
                <mat-label>Correo</mat-label>
                <input
                    matInput
                    type="text"
                    name="email"
                    required
                    [(ngModel)]="coleccionista.correoElectronico"
                    placeholder="Email"
                    pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$"
                    #correoInput="ngModel"
                />
                <mat-error *ngIf="correoInput.errors?.['required'] && correoInput.touched">
                    El correo es obligatorio.
                </mat-error>
                <mat-error *ngIf="correoInput.errors?.['pattern'] && correoInput.touched">
                    El formato del correo no es válido.
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-full fuse-mat-dense">
                <mat-label>Número de Telefóno</mat-label>
                <input matInput type="tel" required placeholder="Número de Telefóno" id="telefono" 
                name="telefono" 
                [(ngModel)]="coleccionista.telefono" 
                pattern="^[0-9]{8,}$"
                autocomplete="off"
                #numero="ngModel">
                <mat-error *ngIf="numero.errors?.required && numero.touched">
                    Este campo es obligatorio.
                </mat-error>

                <mat-error *ngIf="numero.errors?.pattern && numero.touched">
                    Debe contener al menos 8 dígitos numéricos.
                </mat-error>
            </mat-form-field>  


            <mat-form-field class="w-full fuse-mat-dense">
                <mat-label>Cui</mat-label>
                <input matInput type="text" id="cui" name="cui" [(ngModel)]="coleccionista.cui" placeholder="cui"/>
            </mat-form-field>

            <mat-form-field class="w-full fuse-mat-dense">
                <mat-label>Nit</mat-label>
                <input matInput type="text" id="nit" name="nit" [(ngModel)]="coleccionista.nit" placeholder="nit"/>
            </mat-form-field>

            <mat-form-field class="w-full fuse-mat-dense">
                <mat-label>Departamentos</mat-label>
                <input type="text" required name="departamento" id="departamento"
                        matInput
                        [(ngModel)]="coleccionista.departamento"
                        placeholder="Selecciona un departamento"
                        [matAutocomplete]="auto"
                        (input)="filter$.next($event.target.value)">

                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="getMunicipios($event.option.value)">
                    <mat-option *ngFor="let option of (filteredOptions$ | async)" [value]="option">
                    {{ option.descripcion }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>     
            
            <mat-form-field class="w-full fuse-mat-dense">
                <mat-label>Municipio</mat-label>
                <input type="text"
                        matInput
                        [(ngModel)]="coleccionista.municipio"
                        name="municipio"
                        id="municipio"
                        [matAutocomplete]="autoMunicipio"
                        (input)="filterMunicipios$.next($event.target.value)"
                        />

                <mat-autocomplete
                    #autoMunicipio="matAutocomplete" 
                    [displayWith]="displayFnMunicipio">
                    <mat-option *ngFor="let m of municipios$ | async" [value]="m">
                    {{ m.descripcion }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

        </div>
         
        <div class="text-gray-700 font-medium">Sección*</div>
        <mat-radio-group 
            [(ngModel)]="coleccionista.seccion" 
            name="tipoColeccion" id="tipoColeccion" 
            (change)="tipoSeccion($event.value)"
            required>
            @for (c of tipoColeccion; track c) {
                @if(c.tipologiaId != bienes_inmuebles){
                    <mat-radio-button (click)="getColeccion(c.tipologiaId)" [value]="c"> 
                        <p class="text-gray-700">{{c.descripcion}}</p>
                    </mat-radio-button>
                }
               
            }
        </mat-radio-group>
        
        <div class="flex flex-col mb-2">
            <label class="text-gray-700 font-medium">Titular*</label>
            <mat-radio-group [(ngModel)]="coleccionista.titular" aria-label="Select an option" name="titular" id="titular" required>
                    @for (t of titular; track t) {
                    <mat-radio-button 
                        [value]="t" 
                        [disabled]="isPrehispanica && t.tipologiaId === ID_BLOQUEADO"> 
                        <p class="text-gray-700 text-md">{{t.descripcion | titlecase}}</p>
                    </mat-radio-button>
                    }
            </mat-radio-group>
        </div>

        <mat-form-field class="w-full fuse-mat-dense">
            <mat-label>Tipo Representación</mat-label>
            <mat-select [(ngModel)]="coleccionista.tipoRepresentacion" name="tipoRepresentacion" id="tipoRepresentacion" required>
                @for (tipo of tipoRepresentacion; track tipo) {
                    <mat-option [value]="tipo">{{tipo.descripcion}}</mat-option>
                }
            </mat-select>
        </mat-form-field> 
        
        <mat-form-field class="w-full fuse-mat-dense mt-2">
            <mat-label>Colección</mat-label>
                <mat-select [(ngModel)]="coleccionista.coleccion" name="coleccion" id="coleccion" required>
                    @for (c of coleccion; track c) {
                        <mat-option [value]="c">{{c.descripcion}}</mat-option>
                    }
                </mat-select>
        </mat-form-field>

    </form>

    <div class="w-full flex justify-center md:justify-end gap-3 mt-3">
        <button mat-button mat-raised-button
        class=""  
        [color]="'secondary'" (click)="this.dialogRef.close(false);">
        Cancelar
        </button>

        <button mat-flat-button 
        [color]="'primary'" 
        type="submit"
        (click)="crearUsuario()"
        [disabled]="!coleccionistaForm.form.valid">Crear Coleccionista
        </button>
  </div>

</div>